import type { ChangeEventHandler, MouseEventHandler } from 'react'
import type { JourneyTaskView } from '../model/types'
import TaskDetails from './TaskDetails'
import styles from './JourneyPage.module.css'

interface Props {
  task: JourneyTaskView
  saving: boolean
  onChange: ChangeEventHandler<HTMLInputElement>
  onDiscuss: MouseEventHandler<HTMLButtonElement>
}
export default function WeekTask({ task, saving, onChange, onDiscuss }: Props) {
  return <li className={styles.weekTask}>
    <label className={styles.check}>
      <input type="checkbox" value={task.id} checked={task.done} disabled={saving} onChange={onChange} />
      <span>{task.title}</span>
    </label>
    <details>
      <summary>Как выполнить</summary>
      <TaskDetails task={task} />
      <button type="button" className={styles.secondary} value={task.id} onClick={onDiscuss} disabled={saving}>Обсудить задание</button>
    </details>
  </li>
}
